import React, { useEffect, useState, useMemo } from "react";
import { MenuOutlined, UploadOutlined, PlusOutlined, CloseCircleTwoTone } from "@ant-design/icons";
import {
  ellipsisVertical,
  eyeOutline,
  eyeOffOutline,
  trashOutline,
  chevronBackOutline,
  closeOutline,
  trash,
} from "ionicons/icons";

import { IonIcon, IonReorderGroup, IonReorder } from "@ionic/react";
import {
  Button,
  Typography,
  Row,
  Col,
  DatePicker,
  Empty,
  Input,
  Menu,
  Form,
  Modal,
  Table,
  Select,
  Divider,
  AutoComplete,
  notification,
} from "antd";
import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
import dayjs from "dayjs";
import axios from "axios";
import https from "https";
import c from "../../../utils/common";
import log from "../../../utils/log";
import { useTranslation } from "react-i18next";
import produce from "immer";
import deepcopy from "deepcopy";
import { isInt } from "validator";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import ImgCrop from "antd-img-crop";
import { usePhoto } from "../../../hooks/usePhoto";
import { Plugins } from "@capacitor/core";
/* Global State*/

import { style } from "../../../css/css";
import metaData from "../../../data/metaData";
import useAuthStore from "../../../states/useAuth";
import useShop from "../../../hooks/useShop";
import { showErrMsg } from "../../../utils/error";
import { formatTime } from "../../../utils/time";
import CheckBox from "../../../components/General/Checkbox";
import ShopLogo from "../../../components/Shop/Logo";
import Gallery from "../../../components/General/Gallery";
import SectionHeader from "../../../components/GetStarted/SectionHeader";
import PeriodPicker from "../../../components/General/PeriodPicker";
import Meta from "../../../components/Meta";
const { Paragraph, Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Browser } = Plugins;

const description_max_word_count = 1000;
const title_max_word_count = 30;

const DragHandle = SortableHandle(() => (
  <MenuOutlined
    style={{
      cursor: "grab",
      color: "#999",
    }}
  />
));

const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);

const AdBanner = (props) => {
  const { auth, user } = useAuthStore();
  const { getShops } = useShop();
  const [bannerForm] = Form.useForm();

  const [is_loading_ads, set_is_loading_ads] = useState(false);
  const [is_creating_new, set_is_creating_new] = useState(false);
  const [is_submitting, set_is_submitting] = useState(false);

  const [showLogoError1, setShowLogoError1] = useState(false);
  const [showGalleryError1, setShowGalleryError1] = useState(false);

  //visibility
  const [is_open_visibility_dropdown, set_is_open_visibility_dropdown] = useState(false);

  //gallery
  const [refresh_gallery, set_refresh_gallery] = useState(true);

  //related vendor modal
  const [is_show_related_vendor_modal, set_is_show_related_vendor_modal] = useState(false);
  const [vendors, set_vendors] = useState([]);
  const [related_vendors, set_related_vendors] = useState([]);

  //gallery modal
  const [is_show_gallery_modal, set_is_show_gallery_modal] = useState(false);

  const [original_ads, set_original_ads] = useState([]);
  const [ads, set_ads] = useState([]);

  const [active_ad_id, set_active_ad_id] = useState();

  const active_ad = useMemo(() => {
    return ads.find((e) => e.id == active_ad_id);
  }, [original_ads, ads, active_ad_id]);

  const { t, i18n } = useTranslation();
  const { takePhoto } = usePhoto();

  let key = "updatable";

  const uploadProps = {
    name: "upload",
    accept: "image/png, image/jpeg",
    maxCount: 1,
    showUploadList: false,
    beforeUpload: (file) => {
      let url = URL.createObjectURL(file);
      console.log(url);
      document.getElementById("coverPhoto").src = url;
      //
      set_ads(
        produce((draft) => {
          for (let e of draft) {
            if (e.id == active_ad.id) {
              e.coverPhoto = url;
            }
          }
          return draft;
        })
      );
      return false;
    },
  };

  const get_vendors = async () => {
    try {
      const shops = await getShops();
      log.debug(shops);
      set_vendors(shops);
    } catch (error) {
      notification.error({
        message: (
          <Title style={{ margin: 0 }} level={4}>
            Error
          </Title>
        ),
        description: <Text strong>Please refresh this page</Text>,
      });
    } finally {
      // setIsFetchingShops(false);
    }
  };

  const get_ads = async () => {
    try {
      set_is_loading_ads(true);
      log.debug(auth.jwt);
      const res = await axios.post(metaData.serverURL + "ad/banners/query", null, {
        headers: { Authorization: auth.jwt },
        httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
      });
      log.debug(res);
      let data = res.data || [];
      //must add field to array for drag plugin function normally
      for (let i = 0; i < data.length; i++) {
        data[i].key = String(i + 1);
        data[i].index = i;
      }
      //
      set_original_ads(data);
      set_ads(data);
    } catch (error) {
      showErrMsg(error);
    } finally {
      set_is_loading_ads(false);
    }
  };

  const get_data = async () => {
    set_is_loading_ads(true);
    await get_vendors();
    await get_ads();
    set_is_loading_ads(false);
  };

  const create_ad = async () => {
    //checking
    if (is_form_valid() == false) {
      return;
    }

    set_is_submitting(true);

    let data = {
      id: active_ad.id,
      coverPhoto: active_ad.coverPhoto,
      gallery: active_ad.gallery,
      name: active_ad.name,
      description: active_ad.description,
      website: active_ad.website,
      time: active_ad.time,
      vendorIds: active_ad.vendorIds,
      isShow: active_ad.isShow,
    };
    console.log(data);

    //
    const config = {
      headers: {
        Authorization: auth.jwt,
        httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
      },
    };

    const res = await axios.post(metaData.serverURL + "ad/banner/create", data, config);
    console.log(res);

    set_is_submitting(false);
    if (res.data.status == "Error") {
      //
    } else if (res.data.status == "Success") {
      c.message({ type: "success", content: t("AdCarousel.text29") });
      discard_form();
      await get_ads();
    }
  };

  const delete_ad = async (id) => {
    let data = { id };
    const res = await axios.post(metaData.serverURL + "ad/banner/delete", data, {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    console.log(res);
    if (res.data.status == "Error") {
      //
    } else if (res.data.status == "Success") {
      c.message({ type: "success", content: t("AdCarousel.text30") });
      discard_form();
      await get_ads();
    }
  };

  const update_ad = async () => {
    try {
      //checking
      if (is_form_valid() == false) {
        return;
      }

      set_is_submitting(true);

      let data = {
        id: active_ad.id,
        coverPhoto: active_ad.coverPhoto,
        gallery: active_ad.gallery,
        name: active_ad.name,
        description: active_ad.description,
        website: active_ad.website,
        time: active_ad.time,
        vendorIds: active_ad.vendorIds,
        isShow: active_ad.isShow,
        isPopup: active_ad.isPopup,
      };
      console.log(data);

      const config = {
        headers: {
          Authorization: auth.jwt,
          httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
        },
      };

      const res = await axios.post(metaData.serverURL + "ad/banner/update", data, config);
      console.log(res);

      set_is_submitting(false);

      c.message({ type: "success", content: t("AdCarousel.text31") });
      discard_form();
      await get_ads();
    } catch (error) {
      showErrMsg(error);
    }
  };

  const togglePopup = async (ad) => {
    try {
      let data = {
        id: ad.id,
        coverPhoto: ad.coverPhoto,
        gallery: ad.gallery,
        name: ad.name,
        description: ad.description,
        website: ad.website,
        time: ad.time,
        vendorIds: ad.vendorIds,
        isShow: ad.isShow,
        isPopup: !ad.isPopup,
      };

      log.debug(data);

      const config = {
        headers: {
          Authorization: auth.jwt,
          httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
        },
      };

      const res = await axios.post(metaData.serverURL + "ad/banner/update", data, config);

      log.debug(res);
      await get_ads();
    } catch (error) {
      showErrMsg(error);
    }
  };

  const reorder_ads = async (ads) => {
    set_is_loading_ads(true);
    let data = {
      ads: ads.map((e) => {
        return { id: e.id, order: e.order };
      }),
    };
    console.log(data);

    const res = await axios.post(metaData.serverURL + "ad/banner/update/order", data, {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    console.log(res);
    set_is_loading_ads(false);

    if (res.data.status == "Error") {
      //
    } else if (res.data.status == "Success") {
      //show success msg
      //get latest ad list
      await get_ads();
      c.message({ type: "success", content: t("AdCarousel.text31") });
    }
  };

  const get_collectTime_moment_object = (time) => {
    let start = time?.start == null ? "" : moment(time.start);
    let end = time?.end == null ? "" : moment(time.end);
    return [start, end];
  };

  const discard_form = () => {
    if (is_creating_new) {
      set_is_creating_new(false);
    }
    set_active_ad_id();
  };

  const reset_form = () => {
    //replace ads with original_ads
    set_ads(
      produce((draft) => {
        let list = deepcopy(original_ads);
        return list;
      })
    );
  };

  const isObjectsEqual = (obj1, obj2) => {
    // console.log(obj1 + " " + typeof obj1);
    // console.log(obj2 + " " + typeof obj2);

    if (typeof obj1 !== typeof obj2) {
      return false;
    }

    if (typeof obj1 === "object") {
      if (Array.isArray(obj1) !== Array.isArray(obj2)) {
        return false;
      }

      if (obj1 == null || obj2 == null) {
        return obj1 == null && obj2 == null ? true : false;
      }

      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let key of keys1) {
        if (!isObjectsEqual(obj1[key], obj2[key])) {
          return false;
        }
      }

      return true;
    }

    return obj1 === obj2;
  };

  const add_blobURL = (str) => {
    return metaData.blobPreURL + "clientUpload-" + str + ".jpeg" + metaData.blobPostURL;
  };

  const has_changes = () => {
    let compare = deepcopy(active_ad);

    if (compare == null || original_ads.find((e) => e.id == compare.id) == null) {
      return false;
    }

    return !isObjectsEqual(
      original_ads.find((e) => e.id == compare.id),
      compare
    );
  };

  const do_reorder_gallery = (event) => {
    // Before complete is called with the items they will remain in the
    // order before the drag

    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. Update the items variable to the
    // new order of items
    let gallery = deepcopy(active_ad.gallery);
    let item = gallery[event.detail.from];
    gallery.splice(event.detail.from, 1);
    gallery.splice(event.detail.to, 0, item);

    set_ads(
      produce((draft) => {
        for (let e of draft) {
          if (e.id == active_ad_id) {
            e.gallery = gallery;
          }
        }
        return draft;
      })
    );

    event.detail.complete();

    set_refresh_gallery(false);
    set_refresh_gallery(true);

    // After complete is called the items will be in the new order
  };

  //filter out id that exist on related_vendors
  const get_search_list = () => {
    return vendors
      .filter((e) => related_vendors.map((e) => e.id).includes(e.id) == false)
      .map((e) => {
        return {
          label: (
            <Row align="middle">
              <ShopLogo style={{ width: 45, height: 45 }} logo={e?.logo} brandLogo={e?.brand?.logo} />
              {e.name}
            </Row>
          ),
          value: e.name, //for search matching
          vendorId: e.id, //for onSelect
        };
      });
  };

  const remove_gallery_item = (path) => {
    let temp_gallery = deepcopy(active_ad.gallery);
    let i = temp_gallery.indexOf(path);
    temp_gallery.splice(i, 1);
    set_ads(
      produce((draft) => {
        for (let e of draft) {
          if (e.id == active_ad_id) {
            e.gallery = temp_gallery;
          }
        }
        return draft;
      })
    );
  };

  const columns = [
    {
      title: t("AdCarousel.text1"),
      dataIndex: "sort",
      width: 50,
      className: "drag-visible",
      render: () => <DragHandle />,
    },
    {
      title: t("AdCarousel.text2"),
      dataIndex: "name",
      width: 250,
      key: "name",
      className: "drag-visible",
      ellipsis: true,
      render: (text, record) => (
        <Meta
          image={<img style={{ width: 70, height: 40, objectFit: "cover" }} src={add_blobURL(record.coverPhoto)} />}
          title={<span style={{ fontWeight: "bold", marginLeft: 12 }}>{record?.name}</span>}
          description={<span style={{ fontWeight: "bold", marginLeft: 12 }}>{record?.id?.substr(0, 8)}</span>}
          maxWidth={200}
        />
      ),
    },
    {
      title: t("AdCarousel.text3"),
      width: 100,
      dataIndex: "isShow",
      render: (text, record) =>
        record.isShow ? (
          <Row align="middle" style={{ fontSize: 14 }}>
            <IonIcon style={{ marginRight: 10, color: "green" }} icon={eyeOutline} />
            {t("AdCarousel.text3")}
          </Row>
        ) : (
          <Row align="middle" style={{ fontSize: 14 }}>
            <IonIcon style={{ marginRight: 10, color: "gray" }} icon={eyeOffOutline} />
            {t("AdCarousel.text4")}
          </Row>
        ),
    },
    {
      title: "Pop Up",
      width: 100,
      dataIndex: "isPopup",
      render: (text, record) => (
        <CheckBox
          checked={record?.isPopup}
          onClick={() => {
            if (record) {
              if (!record.isPopup && ads.some((e) => e.isPopup)) {
                return notification.warning({ description: "Maximum Popup is 1, please disable existing popup first" });
              }
              togglePopup(record);
            }
          }}
        />
      ),
    },
    // {
    //   title: t("AdCarousel.text5"),
    //   dataIndex: "description",
    //   render: (text, record) => (
    //     <Paragraph
    //       style={{
    //         width: "100%",
    //         fontSize: 12,
    //         margin: 0,
    //       }}
    //       ellipsis={{
    //         rows: 2,
    //       }}
    //     >
    //       {record.description}
    //     </Paragraph>
    //   ),
    // },
    {
      title: "Display time",
      width: 250,
      dataIndex: "time",
      render: (text, record) =>
        !record?.time ? null : (
          <Text>{`${formatTime(record.time.start, "YYYY-MM-DD")} to ${formatTime(
            record.time.end,
            "YYYY-MM-DD"
          )}`}</Text>
        ),
    },
    {
      title: t("AdCarousel.text6"),
      width: 200,
      dataIndex: "website",
      render: (text, record) =>
        record.website == null ? null : (
          <a
            onClick={() => {
              Browser.open({ url: "https://" + record.website });
            }}
          >
            link
          </a>
        ),
    },
    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record) => (
        <a
          onClick={() => {
            set_active_ad_id(record.id);
          }}
        >
          {t("reward.Edit")}
        </a>
      ),
    },
  ];

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      // const newData = arrayMoveImmutable(dataSource.slice(), oldIndex, newIndex).filter(
      //   (el) => !!el,
      // );

      let _ads = deepcopy(ads);
      let item = _ads[oldIndex];
      //reorder
      _ads.splice(oldIndex, 1);
      _ads.splice(newIndex, 0, item);
      //update display_order
      for (let i = 0; i < _ads.length; i++) {
        _ads[i].order = i;
      }
      console.log("Sorted items: ", _ads);
      //set_ads(_ads);
      //axios
      reorder_ads(_ads);
    }
  };

  const DraggableContainer = (props) => (
    <SortableBody useDragHandle disableAutoscroll helperClass="row-dragging" onSortEnd={onSortEnd} {...props} />
  );
  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = ads.findIndex((x) => x.index === restProps["data-row-key"]);
    return <SortableItem index={index} {...restProps} />;
  };

  const is_form_valid = () => {
    if (active_ad.name == null) {
      c.message({ type: "error", content: t("AdCarousel.text7") });
      return false;
    }
    //
    if (active_ad.coverPhoto == null) {
      c.message({ type: "error", content: t("AdCarousel.text8") });
      return false;
    }
    //
    if (active_ad.time == null) {
      c.message({ type: "error", content: "Ad display time is required" });
      return false;
    }
    return true;
  };

  const open_related_vendor_modal = () => {
    //parse ad.vendorIds
    let default_value = [];
    for (let v of active_ad.vendorIds || []) {
      let found = vendors.find((e) => e.id == v);
      default_value.push({ id: v, name: found.name });
    }
    set_related_vendors(default_value);
    set_is_show_related_vendor_modal(true);
  };

  const close_related_vendor_modal = () => {
    set_related_vendors([]);
    set_is_show_related_vendor_modal(false);
  };

  const close_gallery_modal = () => {
    set_is_show_gallery_modal(false);
  };

  /**
   * UI Component
   */
  const render_coverPhoto_error_msg = () => {
    return (
      <Modal
        centered
        open={showLogoError1}
        onOk={() => {
          setShowLogoError1(false);
        }}
        onCancel={() => {
          setShowLogoError1(false);
        }}
        footer={null}
      >
        <Row align="middle" style={{ marginRight: 20 }}>
          <Col span={4}>
            <CloseCircleTwoTone style={{ fontSize: 40 }} twoToneColor="#F24621" />
          </Col>
          <Col span={20}>
            <strong style={{ fontSize: 20 }}>{t("edit.LogoError")}</strong>
          </Col>
        </Row>
      </Modal>
    );
  };

  const render_gallery_error_msg = () => {
    return (
      <Modal
        centered
        open={showGalleryError1}
        onOk={() => {
          setShowGalleryError1(false);
        }}
        onCancel={() => {
          setShowGalleryError1(false);
        }}
        footer={null}
      >
        <Row align="middle" style={{ marginRight: 20 }}>
          <Col span={4}>
            <CloseCircleTwoTone style={{ fontSize: 40 }} twoToneColor="#F24621" />
          </Col>
          <Col span={20}>
            <strong style={{ fontSize: 20 }}>{t("edit.OtherError")}</strong>
          </Col>
        </Row>
      </Modal>
    );
  };

  const render_title = () => {
    return (
      <Row style={{ width: "100%" }}>
        <Col span={24}>
          <Row justify="space-between" style={{ width: "100%", marginBottom: 20 }}>
            <Col style={{ fontSize: 22, fontWeight: "bolder" }}>Banner</Col>
            <Col>
              <Button
                disabled={is_loading_ads}
                size="large"
                type="primary"
                style={{ borderRadius: 20, marginLeft: 20 }}
                onClick={() => {
                  //add temp obj to ad list
                  let copy = deepcopy(ads);
                  let newId = uuidv4();
                  copy.push({ id: newId, gallery: [], isShow: true });
                  set_ads(copy);
                  //open form
                  set_is_creating_new(true);
                  set_active_ad_id(newId);
                }}
              >
                {t("reward.Create")}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const render_overview_table = () => {
    return (
      <Table
        pagination={false}
        dataSource={ads}
        columns={columns}
        rowKey="index"
        loading={is_loading_ads}
        components={{
          body: {
            wrapper: DraggableContainer,
            row: DraggableBodyRow,
          },
        }}
      />
    );
  };

  const render_more_option = () => {
    return (
      <Menu
        items={[
          {
            label: <strong>刪除</strong>,
            key: "1",
            onClick: () => {
              Modal.confirm({
                title: "確定刪除? 此動作無法復原",
                //content: "some messages...some messages...",
                onOk: () => {
                  delete_ad(active_ad.id);
                },
              });
            },
          },
          // {
          //   label: <strong>{t("ticket.Template")}</strong>,
          //   key: "2",
          //   onClick: () => {
          //     console.log("show modal template");
          //     //setShow_modal_add_term_template(true);
          //   },
          // },
        ]}
      ></Menu>
    );
  };

  const render_detail = () => {
    const render_placeholder = () => {
      return (
        <Empty
          style={{ minHeight: "60vh", marginTop: 50 }}
          description={<div style={{ fontSize: 18 }}>{t("AdCarousel.text9")}</div>}
        />
      );
    };
    const render_ad_action_header = () => {
      return (
        <Row
          justify="space-between"
          style={{
            width: "100%",
            position: "sticky",
            background: style.gray1,
            padding: 15,
            borderBottom: "1px solid #DADADA",
            zIndex: 1,
            top: 0,
          }}
        >
          <Col style={{ fontSize: 18, fontWeight: "bolder" }}>
            {render_back_btn()}
            <span style={{ marginLeft: 25 }}>{t("AdCarousel.text10")}</span>
          </Col>
          {is_creating_new ? (
            <Col>
              <Button
                type="primary"
                shape="round"
                size="large"
                disabled={is_submitting}
                style={{ marginRight: 5 }}
                onClick={() => {
                  create_ad();
                }}
              >
                {t("AdCarousel.text11")}
              </Button>
            </Col>
          ) : (
            <Col>
              <Button
                type="text"
                size="large"
                style={{ marginRight: 5 }}
                disabled={has_changes() == false || is_submitting}
                onClick={() => {
                  reset_form(false);
                }}
              >
                {t("AdCarousel.text12")}
              </Button>

              <Button
                type="primary"
                shape="round"
                size="large"
                disabled={has_changes() == false || is_submitting}
                style={{ marginRight: 5 }}
                onClick={() => {
                  update_ad();
                }}
              >
                {t("AdCarousel.text13")}
              </Button>
              {/* <Dropdown overlay={render_more_option()} trigger={["click"]}>
              </Dropdown> */}
              <Button
                type="text"
                shape="round"
                size="large"
                onClick={() => {
                  Modal.confirm({
                    title: t("AdCarousel.text14"),
                    //content: "some messages...some messages...",
                    onOk: () => {
                      delete_ad(active_ad.id);
                    },
                  });
                }}
                style={{ textAlign: "center" }}
              >
                <IonIcon icon={trash} /> {t("AdCarousel.text15")}
              </Button>
            </Col>
          )}
        </Row>
      );
    };
    return (
      <Row style={{ width: "100%", border: "1px solid #DADADA" }}>
        {render_ad_action_header()}
        {render_content()}
      </Row>
    );
  };

  const render_gallery = (item) => {
    return refresh_gallery ? (
      <IonReorderGroup
        disabled={false}
        onIonItemReorder={do_reorder_gallery}
        style={{ marginBottom: "10%", width: "100%" }}
      >
        {item.gallery.length > 0
          ? item.gallery.map((path, i) => (
              <Row key={i} style={{ margin: "10px", width: "100%" }}>
                <Col span={4}>
                  <IonReorder slot="start" />
                </Col>
                <Col span={16} style={{ textAlign: "center" }}>
                  <img
                    //className="imgContainer-cover-xs"
                    style={{ maxHeight: 150, objectFit: "contain" }}
                    src={path}
                    //src={`${metaData.blobPreURL}clientUpload-${path}.jpeg${metaData.blobPostURL}`}
                  />
                </Col>
                <Col span={4}>
                  <Row justify="center" style={{ fontSize: "18px" }}>
                    <IonIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        remove_gallery_item(path);
                      }}
                      icon={trashOutline}
                    ></IonIcon>
                  </Row>
                </Col>
              </Row>
            ))
          : null}
      </IonReorderGroup>
    ) : null;
  };

  const render_content = () => {
    return (
      <>
        {render_gallery_modal()}
        {render_related_vendor_modal()}
        {render_coverPhoto_error_msg()}
        {render_gallery_error_msg()}
        <Row justify="space-between" style={{ padding: 15, width: "100%" }}>
          <Col span={13}>
            {render_ad_title(active_ad)}
            {render_description(active_ad)}
            {render_website(active_ad)}
            {render_date(active_ad)}
          </Col>
          <Col span={10}>
            {render_photo_picker(active_ad)}
            {render_visibility_selector(active_ad)}
            {render_gallery_selector(active_ad)}
            {render_related_vendor_selector(active_ad)}
          </Col>
        </Row>
      </>
    );
  };

  const render_ad_title = (item) => {
    return (
      <Row style={{ width: "100%", fontSize: 16 }}>
        <span style={{ fontWeight: "bold" }}>{t("AdCarousel.text16")}</span>
        <Input.TextArea
          showCount
          style={{ width: "100%", fontSize: style.inputFontSize }}
          autoSize={{ minRows: 2 }}
          maxLength={title_max_word_count}
          value={item.name}
          onChange={(e) => {
            let value = e.target.value == "" ? null : e.target.value;
            //console.log(value);
            set_ads(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_ad_id) {
                    e.name = value;
                  }
                }
                return draft;
              })
            );
          }}
        />
      </Row>
    );
  };
  const render_description = (item) => {
    return (
      <Row style={{ width: "100%", fontSize: 16 }}>
        {t("ticket.Description")}
        <Input.TextArea
          showCount
          style={{ width: "100%", fontSize: style.inputFontSize }}
          autoSize={{ minRows: 4 }}
          maxLength={description_max_word_count}
          value={item.description}
          onChange={(e) => {
            let value = e.target.value == "" ? null : e.target.value;
            //console.log(value);
            set_ads(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_ad_id) {
                    e.description = value;
                  }
                }
                return draft;
              })
            );
          }}
        />
      </Row>
    );
  };
  const render_website = (item) => {
    return (
      <Row style={{ width: "100%", fontSize: 16, marginBottom: 24 }}>
        {t("AdCarousel.text6")}
        <Input
          size="large"
          addonBefore="https://"
          value={item.website}
          onChange={(e) => {
            let value = e.target.value == "" ? null : e.target.value;
            console.log(value);
            set_ads(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_ad_id) {
                    e.website = value;
                  }
                }
                return draft;
              })
            );
          }}
        />
      </Row>
    );
  };
  const render_date = (item) => {
    return (
      <Row style={{ width: "100%", fontSize: 16, marginBottom: 24 }}>
        <div style={{ width: "100%" }}>Ad Display Time</div>
        <PeriodPicker
          state={{
            data: item?.time,
            form: bannerForm,
            rules: [{ required: true, message: "required" }],
            onChange: (updated) => {
              set_ads(
                produce((draft) => {
                  for (let e of draft) {
                    if (e.id == active_ad_id) {
                      e.time = updated;
                    }
                  }
                  return draft;
                })
              );
            },
            keyName: "time",
          }}
        />
        <Button
          shape="ghost"
          size="large"
          style={{ marginLeft: 25 }}
          onClick={() => {
            set_ads(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_ad_id) {
                    e.time = null;
                  }
                }
                return draft;
              })
            );
          }}
        >
          {t("AdCarousel.text18")}
        </Button>
      </Row>
    );
  };

  const render_back_btn = () => {
    return (
      <Button
        size="large"
        shape="round"
        disabled={is_submitting}
        onClick={() => {
          if (is_creating_new) {
            //remove temp obj from ad list
            let copy = deepcopy(ads);
            copy = copy.filter((e) => e.id != active_ad_id);
            set_ads(copy);
            discard_form();
          } else {
            if (has_changes()) {
              Modal.confirm({
                title: t("AdCarousel.text19"),
                //content: "some messages...some messages...",
                onOk: () => {
                  reset_form(true);
                  discard_form();
                },
              });
            } else {
              reset_form(true);
              discard_form();
            }
          }
        }}
      >
        <Row align="middle">
          <IonIcon icon={chevronBackOutline} />
          {t("AdCarousel.text20")}
        </Row>
      </Button>
    );
  };

  const render_photo_picker = () => {
    return (
      <Row style={{ marginBottom: 20 }}>
        <SectionHeader
          title="Cover Photo"
          description="Required* Upload 1 cover photo. JPG or PNG. Max size of 5MB. Use 16/9 for horizontal OR 9/16 for vertical"
        />
        <Row style={{ width: "50%" }}>
          <Gallery
            state={{
              data: active_ad?.coverPhoto ? [active_ad.coverPhoto] : [],
              onChange: (data) => {
                let id = data?.gallery?.[0];
                set_ads(
                  produce((draft) => {
                    for (let e of draft) {
                      if (e.id == active_ad_id) {
                        e.coverPhoto = id;
                      }
                    }
                    return draft;
                  })
                );
              },
            }}
            readOnly={false}
            MAX={1}
          />
        </Row>
      </Row>
    );
  };

  const render_visibility_selector = (item) => {
    return (
      <Row
        justify="space-between"
        align="middle"
        style={{
          width: "100%",
          borderRadius: 10,
          border: "1px solid " + style.gray2,
          padding: 15,
          fontSize: 18,
          background: "white",
          marginBottom: 25,
        }}
        onClick={() => {
          set_is_open_visibility_dropdown(!is_open_visibility_dropdown);
        }}
      >
        <Col>{t("AdCarousel.text22")}</Col>
        <Col>
          <Select
            value={item.isShow}
            bordered={false}
            open={is_open_visibility_dropdown}
            onSelect={(value) => {
              set_ads(
                produce((draft) => {
                  for (let e of draft) {
                    if (e.id == active_ad_id) {
                      e.isShow = value;
                    }
                  }
                  return draft;
                })
              );
            }}
            size="large"
            options={[
              {
                value: true,
                label: (
                  <Row align="middle" style={{ fontSize: 18 }}>
                    <IonIcon style={{ marginRight: 10, color: "green" }} icon={eyeOutline} />
                    {t("AdCarousel.text3")}
                  </Row>
                ),
              },
              {
                value: false,
                label: (
                  <Row align="middle" style={{ fontSize: 18 }}>
                    <IonIcon style={{ marginRight: 10, color: "gray" }} icon={eyeOffOutline} />
                    {t("AdCarousel.text4")}
                  </Row>
                ),
              },
            ]}
          />
        </Col>
      </Row>

      // <Row align="middle" style={{ marginBottom: 25 }}>
      //   <span style={{ fontSize: 16, marginRight: 25 }}>廣告是否可見</span>
      //   <Select
      //     defaultValue={item.isShow}
      //     onChange={(value) => {
      //       set_ads(
      //         produce((draft) => {
      //           for (let e of draft) {
      //             if (e.id == active_ad_id) {
      //               e.isShow = value;
      //             }
      //           }
      //           return draft;
      //         })
      //       );
      //     }}
      //     size="large"
      //     options={[
      //       {
      //         value: true,
      //         label: (
      //           <Row align="middle" style={{ fontSize: 18 }}>
      //             <IonIcon style={{ marginRight: 10, color: "green" }} icon={eyeOutline} />
      //             可見
      //           </Row>
      //         ),
      //       },
      //       {
      //         value: false,
      //         label: (
      //           <Row align="middle" style={{ fontSize: 18 }}>
      //             <IonIcon style={{ marginRight: 10, color: "gray" }} icon={eyeOffOutline} />
      //             隱藏
      //           </Row>
      //         ),
      //       },
      //     ]}
      //   />
      // </Row>
    );
  };

  const render_gallery_selector = (item) => {
    return (
      <Row
        justify="space-between"
        style={{
          width: "100%",
          borderRadius: 10,
          border: "1px solid " + style.gray2,
          padding: 15,
          fontSize: 18,
          cursor: "pointer",
          background: "white",
          marginBottom: 25,
        }}
        onClick={() => {
          set_is_show_gallery_modal(true);
        }}
      >
        <Col>Gallery: {active_ad.gallery?.length || 0}</Col>
        <Col>+</Col>
      </Row>
    );
  };

  const render_related_vendor_selector = (item) => {
    return (
      <Row
        justify="space-between"
        style={{
          width: "100%",
          borderRadius: 10,
          border: "1px solid " + style.gray2,
          padding: 15,
          fontSize: 18,
          cursor: "pointer",
          background: "white",
        }}
        onClick={() => {
          open_related_vendor_modal();
        }}
      >
        <Col>
          {t("AdCarousel.text24")}: {item.vendorIds?.length || 0}
        </Col>
        <Col>+</Col>
      </Row>
    );
  };

  const render_gallery_modal = () => {
    return (
      <Modal
        title={"Gallery"}
        open={is_show_gallery_modal}
        onOk={() => {
          close_gallery_modal();
        }}
        onCancel={() => close_gallery_modal()}
        bodyStyle={{ padding: 0, height: 500, overflowY: "scroll" }}
        width="60%"
        centered
        maskClosable={false}
      >
        <Row style={{ width: "100%" }}>
          <Row style={{ marginBottom: "2rem" }}>
            <Text type="secondary">
              Max 4 photos. JPG or PNG. Max size of 5MB, You can delete or change the order of the photos.
            </Text>
          </Row>
          <Row style={{ width: "60%" }}>
            <Gallery
              state={{
                data: active_ad?.gallery,
                onChange: (data) => {
                  set_ads(
                    produce((draft) => {
                      for (let e of draft) {
                        if (e.id == active_ad_id) {
                          e.gallery = data.gallery;
                        }
                      }
                      return draft;
                    })
                  );
                },
              }}
              readOnly={false}
              MAX={4}
            />
          </Row>
        </Row>
      </Modal>
    );
  };

  const render_related_vendor_modal = () => {
    return (
      <Modal
        title={`${t("AdCarousel.text24")}: ${related_vendors?.length || 0}`}
        open={is_show_related_vendor_modal}
        onOk={() => {
          set_ads(
            produce((draft) => {
              for (let e of draft) {
                if (e.id == active_ad_id) {
                  e.vendorIds = related_vendors.map((e) => e.id);
                }
              }
              return draft;
            })
          );
          close_related_vendor_modal();
        }}
        onCancel={() => close_related_vendor_modal()}
        bodyStyle={{ padding: 0, height: 500, overflowY: "scroll" }}
        width={500}
        centered
        maskClosable={false}
      >
        <Row style={{ width: "100%" }}>
          {/* <Select {...get_select_bar_props()} /> */}
          <AutoComplete
            style={{ width: "100%", border: "5px solid #f0f2f5", position: "sticky", zIndex: 1, top: 0 }}
            size="large"
            allowClear
            options={get_search_list()}
            placeholder={t("AdCarousel.text28")}
            onSelect={(value, option) => {
              console.log({ value, option });
              let selectedId = option?.vendorId;
              let selected = vendors.find((e) => e.id == selectedId);
              if (selected != null) {
                selected = { id: selected.id, name: selected.name };
                set_related_vendors([...related_vendors, selected]);
              }
            }}
            filterOption={(inputValue, option) => option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
          />

          {related_vendors?.length > 0
            ? related_vendors.map((e, i) => (
                <Row key={i} style={{ width: "100%" }}>
                  <Row justify="start" align="middle" style={{ width: "100%", padding: 10 }}>
                    <Col span={20} style={{ fontSize: 18 }}>
                      {e.name}
                    </Col>
                    <Col span={4} style={{ textAlign: "end" }}>
                      <IonIcon
                        style={{ cursor: "pointer", fontSize: 20, color: "lightred" }}
                        onClick={() => {
                          let copy = deepcopy(related_vendors);
                          copy = copy.filter((c) => c.id != e.id);
                          set_related_vendors(copy);
                        }}
                        icon={closeOutline}
                      ></IonIcon>
                    </Col>
                  </Row>
                  <Divider style={{ marginTop: 5, marginBottom: 5, borderWidth: 2, width: "100%" }} />
                </Row>
              ))
            : null}
        </Row>
      </Modal>
    );
  };

  useEffect(() => {
    get_data();
  }, []);

  return (
    <>
      <div style={{ minHeight: "100vh", width: "100%" }}>
        {active_ad_id == null ? (
          <>
            {render_title()} {render_overview_table()}
          </>
        ) : (
          <Row style={{ marginLeft: 50, marginRight: 50 }}>
            <Row style={{ width: "100%" }}>{render_detail()}</Row>
          </Row>
        )}
      </div>
      <div style={{ marginBottom: "10%" }}></div>
    </>
  );
};

export default AdBanner;
